import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormProvider, useForm } from "react-hook-form";
import { PaziaButton } from "components/atoms";
import { PaziaInput } from "components/atoms";

const schema = yup
  .object({
    name: yup.string().required(),
  })
  .required();
export type TrainerGroupFormValues = yup.InferType<typeof schema>;

interface TrainerGroupFormProps {
  onSubmit: (data: TrainerGroupFormValues) => void;
  name?: string;
}
export const TrainerGroupForm = ({ onSubmit, name }: TrainerGroupFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    values: {
      name: name ?? "",
    },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="max-w-xl grid gap-2">
        <PaziaInput name="name" label="Nazwa" type="text" />
        <div className="pt-4">
          <PaziaButton title="Zapisz" type="success" />
        </div>
      </form>
    </FormProvider>
  );
};
